export enum loggingLocalStorageEnums {
  disableLocalEventLogging = 'disableLocalEventLogging',
  excludeEventNames = 'excludeEventNames',
  excludeEventTags = 'excludeEventTags',
}

type TypeMap = {
  [loggingLocalStorageEnums.disableLocalEventLogging]: boolean;
  [loggingLocalStorageEnums.excludeEventTags]: string[];
  [loggingLocalStorageEnums.excludeEventNames]: string[];
};
type ExtractTypeFromMap<K extends loggingLocalStorageEnums, T = unknown> = K extends keyof TypeMap
  ? TypeMap[K] | null
  : T;

export class LoggingLocalStorage {
  set(key: loggingLocalStorageEnums, value: unknown) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  get<T, K extends loggingLocalStorageEnums>(key: K): ExtractTypeFromMap<K, T> {
    let data = localStorage.getItem(key);
    if (data === null) {
      return null as ExtractTypeFromMap<K, T>;
    }
    try {
      return JSON.parse(data) as ExtractTypeFromMap<K, T>;
    } catch {
      return null as ExtractTypeFromMap<K, T>;
    }
  }

  delete(key: loggingLocalStorageEnums) {
    localStorage.removeItem(key);
  }
}

export const loggingLocalStorage = new LoggingLocalStorage();
